import TourSchedule from '../views/reservations/TourSchedule.vue'
import TourItinerary from '../views/reservations/TourItinerary.vue'
import TourCosting from '../views/reservations/TourCosting.vue'
import BookingForm from '../views/reservations/BookingForm.vue'
import TourSummary from '../views/reservations/TourSummary.vue'

import FinanceInvoice from '../views/finance/FinanceInvoice.vue'
import FinanceQuotes from '../views/finance/FinanceQuotes.vue'
import FinancePayments from '../views/finance/FinancePayments.vue'

import TourPermits from '../views/permits/TourPermits.vue'
import HeldPermits from '../views/permits/HeldPermits.vue'
import BookedPermits from '../views/permits/BookedPermits.vue'



export default [

    // reservations: [ "SalesSchedule", "SalesItinerary", "SalesCosting", "SalesBooking", "SalesSummary", 
    // "TourInvoiceSales", "TourQuoteSales", "TourPermitSales", ],
    {
        path: '/reservations/schedule',
        name: 'SalesSchedule',
        component: TourSchedule
    },
    {
        path: '/reservations/itinerary',
        name: 'SalesItinerary',
        component: TourItinerary
    },
    {
        path: '/reservations/costing',
        name: 'SalesCosting',
        component: TourCosting
    },
    {
        path: '/reservations/booking',
        name: 'SalesBooking',
        component: BookingForm
    },
    {
        path: '/reservations/summary',
        name: 'SalesSummary',
        component: TourSummary
    },
    {
        path: '/reservations/invoice',
        name: 'TourInvoiceSales',
        component: FinanceInvoice
    },
    {
        path: '/reservations/quotes',
        name: 'TourQuoteSales',
        component: FinanceQuotes
    },
    {
        path: '/reservations/permits',
        name: 'TourPermitSales',
        component: TourPermits
    },

];